import type { AppColorKeys } from '@fc-core/constants/colors';
import type { AppIconsType } from '@fc-shared/ui/icon/icons';

export type SnackbarType = 'success' | 'error' | 'warning';

export interface SnackbarAppearance {
  icon: AppIconsType;
  iconColor: AppColorKeys;
  iconBackgroundClass: string;
}

export const SNACKBAR_APPEARANCE: Record<SnackbarType, SnackbarAppearance> = {
  success: {
    icon: 'icon-info_filled',
    iconColor: 'primary600',
    iconBackgroundClass: 'bg-primary-100',
  },
  error: {
    icon: 'icon-cancel',
    iconColor: 'error600',
    iconBackgroundClass: 'bg-error-100',
  },
  warning: {
    icon: 'icon-warning-bold',
    iconColor: 'warning600',
    iconBackgroundClass: 'bg-warning-100',
  },
};
